import {Controller} from "stimulus";
import {getPortfoliosDropdown} from "../../routes/portfolio";
import {enter, leave} from "el-transition";
import {EventCheckUserLogin} from "../../events";

export default class extends Controller {
  static targets = [
      // Navbar items
      "loggedInItem", "loggedOutItem", "developerGroup", "subscribeButton", "candyItem", "portfolioItem", "portfolioMenu",
      // Authorship Controls
      "authorshipGroup",
      // Export historical data login wall
      "exportDataButton", "exportDataDropdown",
      // Portfolio guide
      "addCoinGeckoGuide",
      // Generic items
       "transition", "placeholder",
  ];

  connect() {
    fetch("/accounts/logged_in_user.json", { credentials: "same-origin" })
      .then(response => response.json())
      .then(data => { this._handleLoginState(data) });
  }

  _handleLoginState(data) {
    const isLoggedIn = !!data.current_user;

    // Show/hide login/sign up buttons and user account menu buttons.
    this.loggedInItemTargets.forEach(target => { target.classList.toggle("tw-hidden", !isLoggedIn) });
    this.loggedOutItemTargets.forEach(target => { target.classList.toggle("tw-hidden", isLoggedIn) });

    // Handle more complex logged in/out states.
    isLoggedIn ? this._handleLoggedIn(data) : this._handleLoggedOut();

    // Fade in transition targets after updating state.
    this.placeholderTargets.forEach(target => { target.classList.add("!tw-hidden") });
    this.transitionTargets.forEach(target => {
      target.classList.remove("!tw-hidden");
      enter(target, "fade");
    });

    // Inform listeners about the recent login change.
    window.dispatchEvent(new CustomEvent(EventCheckUserLogin, { detail: { userLoggedIn: isLoggedIn } }));
  }

  _handleLoggedIn(data) {
    const isPremium = !!data.has_subscription;
    const hasApiAccess = !!data.has_enterprise_api_subscription;
    const hasAuthorship = !!data.has_authorship;

    // Toggle logged in state; developer dashboard button, premium button, and candy link.
    this.subscribeButtonTargets.forEach(target => { target.classList.toggle("tw-hidden", isPremium) });
    this.developerGroupTargets.forEach(target => { target.classList.toggle("tw-hidden", !hasApiAccess) });
    this.authorshipGroupTargets.forEach(target => { target.classList.toggle("tw-hidden", !hasAuthorship) });
    this.candyItemTargets.forEach(target => { target.href = target.dataset.url });


    // Dynamically load portfolio dropdown.
    getPortfoliosDropdown(html => {
      this.portfolioMenuTarget.insertAdjacentHTML("beforeend", html);

      // Allow hover if portfolio dropdown loaded successfully.
      let actions = this.portfolioItemTarget.dataset.action.split(" ");
      actions.push("mouseover->navbar#handleOver", "mouseout->navbar#handleAway");
      this.portfolioItemTarget.dataset.action = actions.join(" ");

      // Disable link if portfolio dropdown loaded successfully.
      this.portfolioItemTarget.querySelector("a").removeAttribute("href");
    });
  }

  _handleLoggedOut() {
    // Require login to export historical data.
    this.exportDataDropdownTargets.forEach(e => { e.remove() });
    this.exportDataButtonTargets.forEach(e => {
      e.onclick = (e) => {
        e.stopImmediatePropagation();
        Modal.show("auth_modal");
      }
    });

    // Modal for sign up funnel; shown after 3 consecutive coin page visits.
    if (this.hasAddCoinGeckoGuideTarget) {
      this.addCoinGeckoGuideTarget.classList.remove("tw-hidden");
    }
  }
}
